import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	moveIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	removeVersion: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moveIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	moveIssues: {
		id: 'project-directories.versions.delete-version.content.move-version.move-issues',
		defaultMessage: 'Move issues to',
		description: '',
	},
	removeVersion: {
		id: 'project-directories.versions.delete-version.content.move-version.remove-version',
		defaultMessage: 'Remove the version',
		description: '',
	},
	moveIssuesIssueTermRefresh: {
		id: 'project-directories.versions.delete-version.content.move-version.move-issues-issue-term-refresh',
		defaultMessage: 'Move work items to',
		description: '',
	},
});
export default messages;
